import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { SpaceliftVcs } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellSpace from "ds/components/Table/Row/CellSpace";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";

const SpaceliftVcsReposTableSpaceCell = ({
  item: repo,
  ...cellProps
}: TableSimpleCellProps<SpaceliftVcs>) => {
  return (
    <TableSimpleCell {...cellProps}>
      {repo.space ? (
        <TableCellSpace href={`/spaces/${repo.space.id}`}>{repo.space.name}</TableCellSpace>
      ) : (
        <TableCellEmpty />
      )}
    </TableSimpleCell>
  );
};

export default SpaceliftVcsReposTableSpaceCell;
